import { Fragment } from 'react';

const MARKERS = [
  {
    open: '```',
    close: '```',
    Tag: 'code',
    className: 'px-1 py-0.5 rounded bg-[#F0F2F5] font-mono text-[0.92em]',
  },
  { open: '**', close: '**', Tag: 'strong', className: 'font-bold' },
  { open: '*', close: '*', Tag: 'strong', className: 'font-bold' },
  { open: '_', close: '_', Tag: 'em', className: 'italic' },
  { open: '~', close: '~', Tag: 'del', className: 'line-through' },
];

function boundaryBefore(text, index) {
  if (index <= 0) return true;
  return !/[A-Za-z0-9]/.test(text[index - 1]);
}

function boundaryAfter(text, index) {
  if (index >= text.length) return true;
  return !/[A-Za-z0-9]/.test(text[index]);
}

function findClose(text, from, close) {
  let at = text.indexOf(close, from);
  while (at !== -1) {
    const inner = text.slice(from, at);
    if (
      inner &&
      !inner.includes('\n') &&
      !/^\s|\s$/.test(inner) &&
      boundaryAfter(text, at + close.length)
    ) {
      return at;
    }
    at = text.indexOf(close, at + 1);
  }
  return -1;
}

function nextToken(text, from) {
  let best = null;
  const varAt = text.indexOf('{{', from);
  if (varAt !== -1) {
    const match = /^\{\{(\d+)\}\}/.exec(text.slice(varAt));
    if (match)
      best = {
        start: varAt,
        end: varAt + match[0].length,
        type: 'var',
        id: match[1],
      };
  }

  for (let i = from; i < text.length; i++) {
    if (best && i >= best.start) break;
    if (!boundaryBefore(text, i)) continue;
    for (const marker of MARKERS) {
      if (!text.startsWith(marker.open, i)) continue;
      const contentFrom = i + marker.open.length;
      if (text[contentFrom] === ' ' || text[contentFrom] === '\n') continue;
      const closeAt = findClose(text, contentFrom, marker.close);
      if (closeAt === -1) continue;
      const token = {
        start: i,
        end: closeAt + marker.close.length,
        type: 'fmt',
        marker,
        inner: text.slice(contentFrom, closeAt),
      };
      if (!best || token.start < best.start) best = token;
      break;
    }
  }
  return best;
}

function parse(text, renderVariable, keyRef) {
  const nodes = [];
  let i = 0;
  while (i < text.length) {
    const token = nextToken(text, i);
    if (!token) {
      nodes.push(text.slice(i));
      break;
    }
    if (token.start > i) nodes.push(text.slice(i, token.start));
    const key = keyRef.n++;
    if (token.type === 'var') {
      nodes.push(
        <Fragment key={key}>
          {renderVariable ? renderVariable(token.id) : `{{${token.id}}}`}
        </Fragment>,
      );
    } else {
      const { Tag, className } = token.marker;
      nodes.push(
        <Tag key={key} className={className}>
          {parse(token.inner, renderVariable, keyRef)}
        </Tag>,
      );
    }
    i = token.end;
  }
  return nodes;
}

export function renderWhatsAppText(text, renderVariable) {
  if (!text) return null;
  return parse(String(text), renderVariable, { n: 0 });
}
